<div class="flex h-full">
  <!-- Sidebar -->
  <div class="w-64  shadow-md flex-shrink-0 h-full overflow-y-auto border-r border-gray-200">
    <kendo-buttongroup
      selection="single"
      look="flat"
      class="vertical-button-group"
    >
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.ApprovedSocialMedia)"
      >
        Approved Social Media
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.AssistantType)"
      >
        Assistant
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.Bank)"
      >
        Bank
      </button>
     <!--  <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.Branch)"
      >
        Branch
      </button> -->
    <!--   <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.BrokerFirm)"
      >
        Broker Firm
      </button> -->
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.CrdBranch)"
      >
        CRD Branch
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.CrdBranchType)"
      >
        CRD Type
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.Firm)"
      >
        Firm
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.FirmType)"
      >
        Firm Type
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.License)"
      >
        License
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.NoteType)"
      >
        Log
      </button>
    <!--   <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.OfficeType)"
      >
        Office Type
      </button> -->
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.ProType)"
      >
        Pro Desig
      </button>
    <!--   <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.Region)"
      >
        Region
      </button> -->
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.StateFee)"
      >
        State Fee
      </button>
      <button
        kendoButton
        [toggleable]="true"
        class="vertical-button"
        (click)="switchSection(typeSectionEnum.Subscription)"
      >
        Subscription
      </button>
    </kendo-buttongroup>
  </div>

  <!-- Main Content Area -->
  <main class="flex-1 p-4 overflow-y-auto">
    <div [ngSwitch]="currentSection" class="h-full">
      <gd-type-editor-social-media *ngSwitchCase="typeSectionEnum.ApprovedSocialMedia"></gd-type-editor-social-media>
      <gd-type-editor-assistant-type *ngSwitchCase="typeSectionEnum.AssistantType"></gd-type-editor-assistant-type>
      <gd-type-editor-bank *ngSwitchCase="typeSectionEnum.Bank"></gd-type-editor-bank>
      <gd-type-editor-branch *ngSwitchCase="typeSectionEnum.Branch"></gd-type-editor-branch>
      <gd-type-editor-broker-firm *ngSwitchCase="typeSectionEnum.BrokerFirm"></gd-type-editor-broker-firm>
      <gd-type-editor-crd-branch *ngSwitchCase="typeSectionEnum.CrdBranch"></gd-type-editor-crd-branch>
      <gd-type-editor-crd-branch-type *ngSwitchCase="typeSectionEnum.CrdBranchType"></gd-type-editor-crd-branch-type>
      <gd-type-editor-firm-type *ngSwitchCase="typeSectionEnum.Firm"></gd-type-editor-firm-type>
      <gd-type-editor-type-of-firm *ngSwitchCase="typeSectionEnum.FirmType"></gd-type-editor-type-of-firm>
      <gd-type-editor-license-type *ngSwitchCase="typeSectionEnum.License"></gd-type-editor-license-type>
      <gd-type-editor-note-type *ngSwitchCase="typeSectionEnum.NoteType"></gd-type-editor-note-type>
      <gd-type-editor-office-type *ngSwitchCase="typeSectionEnum.OfficeType"></gd-type-editor-office-type>
      <gd-type-editor-pro-type *ngSwitchCase="typeSectionEnum.ProType"></gd-type-editor-pro-type>
      <gd-type-editor-region *ngSwitchCase="typeSectionEnum.Region"></gd-type-editor-region>
      <gd-type-editor-states *ngSwitchCase="typeSectionEnum.StateFee"></gd-type-editor-states>
      <gd-type-editor-subscription *ngSwitchCase="typeSectionEnum.Subscription"></gd-type-editor-subscription>
    </div>
  </main>
</div>
